import request from "@/utils/request";
// 参数设置与同步
export default function () {
  return request({
    url: "/system/region/region",
    method: "GET",
  });
}
